export class CreateVehicleBrandModel {
  public marca = ''
}

export class EditVehicleBrandModel {
  public id = 0
  public marca = ''
}

export class SearchVehicleBrandModel {
  public marca = ''
}
